import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ConsultaFormContainer from "../../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../../components/Container/Container";
import SearchContainer from "../../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../../components/SearchInput/SearchInput";
import { useListManager } from "../../../../contexts/list.manager";
import FormRoles from "../FormRoles/FormRoles";
import ListRoles from "../ListRoles/ListRoles";
import "./ConsultaRoles.css";
import { IdCardLanyard } from "lucide-react";

const ConsultaRoles = () => {
	const { lineSelected } = useListManager();
	const [searchText, setSearchText] = useState("");
	const [filters, setFilters] = useState("");
	const navigate = useNavigate();
	const location = useLocation();
	const [refreshKey, setRefreshKey] = useState(0);

	useEffect(() => {
		if (location.state?.deletedId || location.state?.refresh) {
			setRefreshKey((k) => !k);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, navigate, location.pathname]);

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					icon={<IdCardLanyard size={23} />}
					title="Perfis"
					navigate="../cadastro-papeis"
					description="Buscar por Nome"
					buttonLabel="Adicionar Perfil"
				>
					<SearchInput
						value={searchText}
						placeholder="Buscar Perfil"
						onChange={({ target }) => setSearchText(target.value)}
						onKeyPress={(e) => e.key === "Enter" && setFilters(searchText)}
					/>
				</SearchContainer>
				<Container>
					<ListRoles
						filters={filters}
						lineSelected={lineSelected ? true : false}
						refreshKey={refreshKey}
					/>
				</Container>
			</div>
			<ConsultaFormContainer>
				<FormRoles role={lineSelected} type="consulta" />
			</ConsultaFormContainer>
		</div>
	);
};

export default ConsultaRoles;
